import { JsonLd } from "@/components/seo/json-ld"

interface FaqSchemaProps {
  faqs: Array<{ question: string; answer: string }>
  /** Unique id so multiple FaqSchemas on the same page don't dedupe each other. */
  id?: string
}

export function FaqSchema({ faqs, id = "tool-faq-schema" }: FaqSchemaProps) {
  return (
    <JsonLd
      id={id}
      data={{
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqs.map(faq => ({
          "@type": "Question",
          "name": faq.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": faq.answer,
          },
        })),
      }}
    />
  )
}
